
import React, { useState, useEffect } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { Trans } from 'react-i18next';
const useStyles = makeStyles(styles);

const GerenciaAlertDelete = () => { 

    const classes = useStyles();

    const [alert, setAlert] = useState({
        componente:(null),
        isToDelete: false,
        idToDeleteSend: 0
    });
    const [confAlert, setConfAlert] = useState({
        statusAlert:0,
        idToDeleteRecieve:0
    });
    /*
    statusAlert
    1 - showalert
    2 - hideAlert
    3 - sucess 
    */

    useEffect(() => {
        
      //console.log(confAlert);

      if(confAlert.statusAlert===1)
      {
        showAlertDelete(confAlert.idToDeleteRecieve);      
      }
      else if(confAlert.statusAlert===2)
      {
        hideAlertDelete();    
      }
      else if(confAlert.statusAlert===3)
      {
        successDelete();    
      }
      
    }, [confAlert]);
  
    const confirmDelete = (id) =>{
        setAlert(
            {
                componente:null,
                isToDelete:true,
                idToDeleteSend: id
            }
        );
      
    }

    const showAlertDelete = (id) => {
             
        setAlert(
            {
                componente:(<SweetAlert
                    warning
                    style={{ display: "block", marginTop: "-200px" }}
                    title={<Trans i18nKey="information_message.confirm_delete_message">
                                Tem certeza que deseja deletar esse registro?
                            </Trans>}
                    onConfirm={() => confirmDelete(id)}
                    onCancel={() => setConfAlert({statusAlert:2})}
                    confirmBtnCssClass={classes.button + " " + classes.success}
                    cancelBtnCssClass={classes.button + " " + classes.danger}
                    confirmBtnText={<Trans i18nKey="information_message.confirm_delete_record"> Sim, delete o registro! </Trans>}
                    cancelBtnText={<Trans i18nKey="button.cancel"> Cancelar </Trans>}
                    showCancel 
                    >
                        {<Trans i18nKey="information_message.warning_delete_message">
                            Tem certeza que deseja deletar esse registro?
                        </Trans>}                     
                    </SweetAlert>),
                isToDelete: false
            }
        );
    };

    const successDelete = () => {

        setAlert(
            {
                componente:(<SweetAlert
                    success
                    style={{ display: "block", marginTop: "-200px" }}
                    title={<Trans i18nKey="information_message.deleted"> Deletado! </Trans>}
                    onConfirm={() => setConfAlert({statusAlert:2})}
                    confirmBtnCssClass={classes.button + " " + classes.success}
                    >
                    {<Trans i18nKey="information_message.deleted_successfully">
                        O seu registro foi deletado com sucesso.
                    </Trans>}                      
                    </SweetAlert>),
                isToDelete: false
            }
        );

    };
    
    const hideAlertDelete = () => {
        setAlert(
            {
                componente:(null),
                isToDelete: false,
                idToDelete: 0
            }
        );
    };
  
    return [alert, setConfAlert];
  };
  
  export {GerenciaAlertDelete};